<script>
export default {
  data() {
    return {
      register: false,
      login: false,
    };
  },
  created() {
    this.$bus.on(this.$events.OPEN_MODAL_REGISTER, (value) => {
      this.register = value;
    });
    this.$bus.on(this.$events.OPEN_MODAL_LOGIN, (value) => {
      this.login = value;
    });
  },
  methods: {
    registerModal() {
      this.register = !this.register;
      this.$bus.emit(this.$events.OPEN_MODAL_REGISTER, this.register);
    },
    loginModal() {
      this.login = !this.login;
      this.$bus.emit(this.$events.OPEN_MODAL_LOGIN, this.login);
    },
  },
};
</script>
